import React, { useRef } from "react";
import "../styles/About.css";

// Assets
import storyImage from "../assets/herosection.jpg";
import founderImg from "../assets/founder.jpg";
import missionIcon from "../assets/Mission.png";
import visionIcon from "../assets/vision.png";


// Ourteam Assets
import employeeImage from "../assets/profile.png";
import kvkrao from "../assets/founder.jpg";
import SriHarsha from "../assets/sriharsha.jpg";
import sam from '../assets/Rehab staff/Sam.JPG';

// Components
import Footer from "../components/Footer";

// Team Members Data (unchanged)
const teamMembers = [
  {
    name: "Dr. Rev. K. V. K. Rao",
    role: "Honorable Founder & Correspondent ",
    bio: "Visionary leader dedicated to quality education and skill development.",
    image: kvkrao,
  },
  {
    name: "Smt. C. V. N. V. Bharathi Devi",
    role: "Honorable President",
    bio: "Dedicated to enhancing educational standards.",
    image: employeeImage,
  },
  {
    name: "Mr. Joseph Sri Harsha Shashank",
    role: "Honorable Secretary",
    bio: "Committed to fostering innovation in education.",
    image: SriHarsha,
  },
  {
    name: "Smt. Indu Aparna",
    role: "Honorable Vice President",
    bio: "Passionate about empowering students through education.",
    image: employeeImage,
  },
  {
    name: "Smt. Indraja",
    role: "- Treasurer",
    bio: "Dedicated to community service and educational outreach.",
    image: employeeImage,
  },
  {
    name: "Mr. T. Sam",
    role: "Director of Operations",
    bio: "Oversees daily operations ensuring excellence and efficiency.",
    image: sam,
  },
  {
    name: "Mr. T. Raja Shekar",
    role: "- Administrative Officer",
    bio: "Administration expert ensuring smooth operations.",
    image: employeeImage,
  },
  {
    name: "Mrs. Navya",
    role: "PA to Vice President",
    bio: "Efficiently managing executive schedules and communications.",
    image: employeeImage,
  },
];

const About = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
  const container = scrollRef.current;
  const cardWidth = container.querySelector(".team-card")?.offsetWidth || 300;
  const gap = 24; // matches CSS gap
  const scrollAmount = cardWidth + gap;

  if (direction === "left") {
    container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  } else {
    container.scrollBy({ left: scrollAmount, behavior: "smooth" });
  }
};


  return (
    <div>
      {/* Our Story */}
      <section className="our-story">
        <div className="story-content">
          <h2 className="title">Our Story</h2>
          <div className="quote-section">
            <p className="story-text">
              St. Mary’s Institute for Future Skills was founded by the visionary leader Dr. Rev. K. V. K. Rao.
              In the year 1996, his vision gave rise to Joseph Sri Harsha &amp; Mary Indraja Educational Society,
              which currently has a strong foothold of 28 institutions offering quality education to urban,
              semi-urban &amp; rural students of India and abroad. SMIFS has spread across 8 states under his
              leadership, providing rural youth skill development programs sponsored by the Ministry of Rural Development, GoI.
            </p>
          </div>
        </div>

        <div className="story-image">
          <img src={storyImage} alt="Campus view" />
        </div>
      </section>

      {/* Founder */}
      <section className="founder-card-container">
        <div className="founder-card-image">
          <img src={founderImg} alt="Founder Dr. Rev. K. V. K. Rao" />
        </div>

        <div className="founder-card-text">
          <h2 className="founder-title">Our Founder</h2>
          <h3 className="founder-name">Dr. Rev. K. V. K. Rao</h3>
          <p className="founder-description">
            St. Mary's Institute for Future Skills was founded by the visionary leader Dr. Rev. K. V. K. Rao.
            In the year 1996, his vision gave rise to Joseph Sri Harsha &amp; Mary Indraja Educational Society,
            which currently has a strong foothold of 28 institutions offering programs to student communities
            by providing quality education to urban, semi-urban &amp; rural students of India and abroad.
            SMIFS has spread across 8 states in the country under his able leadership, providing rural youth
            skill development programs sponsored by the Ministry of Rural Development, GoI.
          </p>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="target-section">
        <div className="target-box">
          <img src={visionIcon} alt="Vision icon" className="target-icon" />
          <h2>Our Vision</h2>
          <p>
            To foster human dignity by encouraging a self-reliant life among people with illnesses, injuries,
            or disabilities through standard rehabilitation practices that restore physical, mental, emotional,
            and spiritual well-being.
          </p>
        </div>

        {/* visual spacing only; dividers hidden in CSS */}
        <div className="divider" />
        <div className="mobile-divider" />

        <div className="target-box">
          <img src={missionIcon} alt="Mission icon" className="target-icon" />
          <h2>Our Mission</h2>
          <p>
            To ensure the highest level of disability recovery and maximum participation of people in life
            with excellence in rehabilitation services, covering physical, mental, emotional, and spiritual well-being.
          </p>
        </div>
      </section>

      
      {/* Meet Our Team Section */}
      <section className="team-section" id="team">
        <h2 className="team-heading">Meet Our Team</h2>
        <p className="team-subheading">
          A dedicated team of professionals driving excellence at St. Mary’s.
        </p>

        <div className="team-carousel-wrapper">
          <button className="team-scroll-btn left" onClick={() => scroll("left")}>&#10094;</button>

          <div className="team-cards" ref={scrollRef}>
            {teamMembers.map((member, index) => (
              <div className="team-card" key={index}>
                <div className="team-img-wrapper">
                  <img src={member.image} alt={member.name} className="team-img" />
                </div>
                <div className="team-info">
                  <h3 className="team-name">{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                  <p className="team-bio">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>

          <button className="team-scroll-btn right" onClick={() => scroll("right")}>&#10095;</button>
        </div>
      </section>


      <Footer />
    </div>
  );
};

export default About;
